import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      minHeight: '53vh',
      borderRadius: 24,
      overflow: 'hidden',
      boxShadow: '0 32px 80px rgba(15, 23, 42, 0.22)',
    },
    selectStepTitle: {
      padding: 0,
    },
    stepHero: {
      padding: theme.spacing(3, 3, 1),
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      gap: theme.spacing(2),
      background:
        'radial-gradient(circle at top right, rgba(255,255,255,0.22), transparent 30%), linear-gradient(135deg, #132f7c 0%, #1d4ed8 52%, #60a5fa 100%)',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    stepKicker: {
      fontSize: '0.72rem',
      fontWeight: 700,
      letterSpacing: '0.16em',
      textTransform: 'uppercase',
      color: 'rgba(191, 219, 254, 0.86)',
    },
    stepHeading: {
      color: '#f8fafc',
      fontWeight: 800,
      letterSpacing: '-0.03em',
    },
    stepSubtitle: {
      color: 'rgba(226, 232, 240, 0.84)',
      lineHeight: 1.7,
      maxWidth: 620,
    },
    selectionBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      padding: theme.spacing(1, 1.5),
      borderRadius: 999,
      border: '1px solid rgba(255,255,255,0.14)',
      background:
        'linear-gradient(180deg, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0.08) 100%)',
      color: '#ffffff',
      fontWeight: 700,
      fontSize: '0.84rem',
      backdropFilter: 'blur(8px)',
    },
    selectStepContent: {
      padding: theme.spacing(2, 2, 2),
      background:
        'radial-gradient(circle at top left, rgba(59,130,246,0.06), transparent 28%), linear-gradient(180deg, #f8fbff 0%, #ffffff 100%)',
    },
    filterSurface: {
      padding: theme.spacing(2),
      borderRadius: 20,
      border: '1px solid rgba(148, 163, 184, 0.16)',
      background:
        'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.96) 100%)',
      boxShadow: '0 18px 42px rgba(15, 23, 42, 0.08)',
      marginBottom: theme.spacing(2),
    },
    filterHeader: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: theme.spacing(2),
      marginBottom: theme.spacing(1.5),
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    filterContainer: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: theme.spacing(1.25),
    },
    filterMeta: {
      color: '#475569',
      fontSize: '0.84rem',
      fontWeight: 700,
      whiteSpace: 'nowrap',
    },
    tableSurface: {
      borderRadius: 20,
      border: '1px solid rgba(148, 163, 184, 0.16)',
      background:
        'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.96) 100%)',
      boxShadow: '0 18px 42px rgba(15, 23, 42, 0.08)',
      overflow: 'hidden',
    },
    tableHeader: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: theme.spacing(2),
      padding: theme.spacing(2, 2.25, 1.5),
      borderBottom: '1px solid rgba(148, 163, 184, 0.12)',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    surfaceTitle: {
      color: '#0f172a',
      fontWeight: 700,
    },
    surfaceSubtitle: {
      color: '#64748b',
      marginTop: theme.spacing(0.5),
    },
    tableHeadRow: {
      backgroundColor: 'rgba(248, 250, 252, 0.9)',
    },
    tableHeadCell: {
      color: '#',
      fontWeight: 700,
      borderBottom: '1px solid rgba(148, 163, 184, 0.12)',
    },
    resultRow: {
      '&:hover': {
        backgroundColor: 'rgba(239, 246, 255, 0.72)',
      },
    },
    tablePagination: {
      borderTop: '1px solid rgba(148, 163, 184, 0.12)',
    },
    selectStepActions: {
      padding: theme.spacing(2, 3, 2),
      justifyContent: 'space-between',
      alignItems: 'center',
      background:
        'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(248,250,252,0.94) 42%)',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: theme.spacing(1),
      },
    },
    actionHint: {
      color: '#64748b',
      fontSize: '0.88rem',
      lineHeight: 1.6,
      maxWidth: 440,
    },
    actionShell: {
      display: 'flex',
      gap: theme.spacing(1),
      padding: theme.spacing(0.75),
      borderRadius: 999,
      border: '1px solid rgba(148, 163, 184, 0.16)',
      background:
        'linear-gradient(135deg, rgba(255,255,255,0.94) 0%, rgba(248,250,252,0.88) 100%)',
      boxShadow: '0 16px 36px rgba(15, 23, 42, 0.08)',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    secondaryAction: {
      minHeight: 44,
      padding: theme.spacing(0, 2),
      borderRadius: 999,
      textTransform: 'none',
      fontWeight: 700,
      boxShadow: 'none',
      [theme.breakpoints.down('sm')]: {
        flex: 1,
      },
    },
    primaryAction: {
      minHeight: 44,
      padding: theme.spacing(0, 2.5),
      borderRadius: 999,
      textTransform: 'none',
      fontWeight: 700,
      background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 55%, #60a5fa 100%)',
      boxShadow: '0 14px 30px rgba(37, 99, 235, 0.24)',
      '&:hover': {
        background: 'linear-gradient(135deg, #1d4ed8 0%, #2563eb 55%, #3b82f6 100%)',
        boxShadow: '0 16px 34px rgba(37, 99, 235, 0.28)',
      },
      [theme.breakpoints.down('sm')]: {
        flex: 1,
      },
    },
  }),
);

export default useStyles;
